import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";

/**
 * Hello World Step
 *
 * A simple utility step for testing and demonstration purposes.
 * Takes a name input and returns a greeting with timestamp.
 */
export const helloWorldStep = defineStepConfig({
  type: "hello_world",
  name: "Hello World",
  description: "Simple greeting step for testing workflow execution",
  category: "Utility",

  inputSchema: z.object({
    name: z.string().describe("Name to greet"),
  }),

  outputSchema: z.object({
    greeting: z.string().describe("Generated greeting message"),
    timestamp: z.string().describe("ISO timestamp when greeting was generated"),
  }),

  configSchema: z.object({
    prefix: z
      .string()
      .prefault("Hello")
      .describe("Greeting prefix (e.g., 'Hello', 'Hi', 'Welcome')"),
  }),

  emits: [] as const,
});
